export const convertArticleInfoToViewModel = (data: any): any => ({
  title: data.title || '',
  providerName: data.providerName || '',
  providerSlug: data.providerSlug || '',
  author: data.author || '',
  credentials: data.credentials && data.credentials.length ? [...data.credentials] : [],
  services: data.services && data.services.length ? [...data.services] : [],
  photoUrl: data.photoUrl || '',
  body: data.body || '',
  description: data.webPageBlurb || '',
});
